import React from "react";
import PropTypes from "prop-types";
import { subscribe } from "venuescanner-js/react/helpers";
import SrpContainer from "../../containers/SrpContainer";
import FiltersContainer from "./FiltersContainer";
import classes from "./filterBar.module.scss";

const ClearFiltersButton = subscribe({ SrpContainer, FiltersContainer })(
  ({
    srpContainer: { hasFilters, clearFilters, refresh },
    filtersContainer,
    then,
  }) =>
    hasFilters && (
      <button
        type="button"
        onClick={() => {
          then();
          clearFilters();
          filtersContainer.reset();
          refresh({ replace: true });
        }}
        className={classes.ClearFiltersButton}
      >
        Clear all
      </button>
    )
);

ClearFiltersButton.propTypes = {
  then: PropTypes.func.isRequired,
};

export default ClearFiltersButton;
